import { file, Tick, CloseSolid, arrow_tip, three_dots} from '../../assets/images'
import { Popover } from 'antd'
import { SALES_ROLE } from '../../constants/overview';


const recentSearchSchema = ({ data, handler, download = false, statusChange, type = '' }) => {
  return (
    <tr key={data.id} className='text-gray-600'>
      <td className='flex flex-row items-center m-2' style={{width :'20%'}}>
        <img src={file} className='w-4 h-4 cursor-pointer' alt='file' />
        <div className='ml-3 pr-5 py-4 font-semibold whitespace-nowrap'>{data.file_name}</div>
      </td>

      <td className='pl-3 pr-5 py-4' style={{width :'17%'}}>{data.upload_date + ' | ' + data.upload_time}</td>

      <td className='pl-3 pr-5 py-4' style={{width :'20%'}}>
        {data.status_obj && (
          <span className='px-2 inline-flex leading-7 font-semibold rounded-full' style={{ backgroundColor: data.status_obj.background_color, color: data.status_obj.text_color }}>
            {data.status_obj.text}
            </span>
          )
        }
      </td>

      <td className='pl-3 pr-5 py-4' style={{width :'23%'}}>
        <div className='flex flex-row items-center'>
          <div className='m-2'>
            <img src={data.total_records_successful ? Tick : CloseSolid} className='w-3 h-3' alt='file' />
          </div>
          <div>
            {data.total_records_successful > 0 && <div>{data.total_records_successful} employees {type === 'deactivate' ? 'deactivated' :  'registered'}</div>}
            {data.total_records_failure > 0 && <div style={{ color: '#D74651' }}>{data.total_records_failure} {type === 'deactivate' ? 'deactivation' :  'registration'} failed</div>}
          </div>
        </div>
      </td>
      
      <td className='pl-3 pr-5 py-4' style={{width :'17%'}}>{data.source}</td>
      { download &&
        <td className='pl-8 px-5 py-4' style={{width: '12%'}}>
        <Popover
          placement='bottomLeft'
          overlayClassName='popover-width180-xs popover-p0-xs'
          content={
            <ul className='text-gray-600 font-semibold'>
              <li className='p-5 -mx-4 -mb-2 hover:bg-blue-100 hover:text-blue-500 cursor-pointer'  onClick={() => statusChange({ type: 'edf', id: data.id })}>Uploaded file</li>
              { data.total_records_failure > 1 && 
              <li className='p-5 -mx-4 -mb-3 hover:bg-blue-100 hover:text-blue-500 cursor-pointer'  onClick={() => statusChange({ type: 'erf', id: data.id })}>Error file</li>}
            </ul>
          }
          // trigger={ actionAccess ? 'click' : 'none'}
        >
          <img src={three_dots} alt='edit-icon' className='block cursor-pointer' />
        </Popover>
      </td>
      }

      <td className={`pt-3.5 m-0 pr-5 pl-3 ${SALES_ROLE === 'sales' && 'cursor-not-allowed'}`} style={{width :'8%'}}>
        <p className={`hover:bg-blue-100 w-10 pl-3.5 py-3.5  rounded-md ${ SALES_ROLE === 'sales' ? ' pointer-events-none cursor-not-allowed select-none' : 'cursor-pointer' }`} onClick={() => handler(data.id)} >
          <span className='h-4 w-4'><img src={arrow_tip}  className='-rotate-90 transform'/></span>          
        </p>
      </td>
    </tr>
  ) 
}

export default recentSearchSchema